module.exports = __webpack_public_path__ + "applause.d6e4c0a4.png";